export default __webpack_public_path__ + "static/media/gallery_10.b5c9ef90.jpg";